import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import AppRouter from './components/AppRouter';
import theme from './theme';

function App() {
  useEffect(() => {
    // Déterminer le titre en fonction de la variable d'environnement
    const company = process.env.REACT_APP_COMPANY;
    const title = company === 'legrand' ? 'Admin Legrand' : 'Admin VM';
    document.title = title;
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <AppRouter />
    </ThemeProvider>
  );
}

export default App;
